module.exports = ".action{\n  width: 10%;\n}\n\n.dropdown-menu{\n  left: unset;\n  right: 0;\n}\n\n.table-responsive{\n  overflow-x: unset;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main-settings/branches/branches.component.css
// module id = ./src/app/main-settings/branches/branches.component.css
// module chunks = main